<script>
export default {
    props: {
        title: { type: String, required: false },
        message: { type: String, required: true },
        confirmButtonText: { type: String, required: true },
        styleButton: { type: String, required: true },
        icon: { type: String, required: true },
        redirect: { type: String, required: false },
        htmlContent: { type: String, required: false },
        newTab: { type: String, required: false }
    },
    computed: {
        imageUrl() {
            const regex = /src=["']([^"']+)["']/;
            const matches = this.icon.match(regex);
            return matches ? matches[1] : '';
        }
    },
    methods: {
        showSuccess() {
            this.$swal({
                imageUrl: this.imageUrl,
                title: this.title,
                text: this.message,
                html: this.htmlContent,
                confirmButtonText: this.confirmButtonText,
                showConfirmButton: this.confirmButtonText ? true : false,
                allowOutsideClick: false,
                customClass: {
                    popup: 'swal-custom-popup',
                    confirmButton: this.styleButton
                },
                allowOutsideClick: false,
                didOpen: () => {
                    document.body.classList.remove('swal2-height-auto');
                }
            }).then((result) => {
                if(result.isConfirmed) {

                    if (this.newTab && this.newTab.trim() !== "") {
                        window.open(this.newTab, '_blank');
                    }

                    if (this.redirect && this.redirect.trim() !== "") {
                        window.location.href = this.redirect;
                    }
                }
            });
        }
    },
    mounted() {
        this.showSuccess();
    }
};

</script>
